import React from 'react';
import { Exercise } from '../../../../../models/Exercise';
import { Ticket } from '../../../../../models/Ticket';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import useLocaleByLanguage from '../../../../../../utils/hooks/useLocaleByLanguage';
import ReservationModalAlert from "./ReservationModalAlert";

interface IProps {
  exercise: Exercise;
  ticket: Ticket;
}

const ReservationDetailsGrid: React.FC<IProps> = ({ exercise, ticket }) => {
  const { t } = useTranslation();
  const locale = useLocaleByLanguage();

  // Build details data array with only non-empty values
  const detailsData: { key: string; value: string }[] = [];

  // Data
  if (exercise.startTime) {
    detailsData.push({
      key: "data",
      value: format(new Date(exercise.startTime), "dd.MM.yyyy", { locale }),
    });
  }

  // Godzina (hora)
  if (exercise.startTime) {
    detailsData.push({
      key: "godzina",
      value: format(new Date(exercise.startTime), "HH:mm"),
    });
  }

  // Lokalizacja
  if (exercise.location) {
    detailsData.push({
      key: "lokalizacja",
      value: exercise.location,
    });
  }

  // Trener
  if (exercise.humanName && !exercise.deputyHumanName) {
    detailsData.push({
      key: "trener_opiekun",
      value: exercise.humanName,
    });
  }

  // Zastępca (only if deputy exists)
  if (exercise.deputyHumanName) {
    detailsData.push({
      key: "zastepca",
      value: exercise.deputyHumanName,
    });
  }

  // Strefa (zone)
  if (exercise.zone?.objectId) {
    detailsData.push({
      key: "strefa",
      value: exercise.zone.displayName || "",
    });
  }

  // Bilet/Karnet
  if (ticket.name) {
    detailsData.push({
      key: "bilet_karnet",
      value: ticket.name,
    });
  }

  // Grupa zajeciowa
  if (exercise.exerciseGroup?.displayName) {
    detailsData.push({
      key: "grupa_zajeciowa",
      value: exercise.exerciseGroup.displayName,
    });
  }

  if (detailsData.length === 0) {
    return null;
  }

  return (
    <div className="reservation-details__container">
      <ReservationModalAlert exercise={exercise} />
      <div className="reservation-details__grid">
        {detailsData.map((detail) => (
          <div key={detail.key} className="reservation-details__item">
            <span className="body-text-small text-color-light-gray">{t(detail.key)}</span>
            <b className="body-text-small text-color-dark">{detail.value}</b>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReservationDetailsGrid;
